import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="w-full bg-[#FAFAF7] text-[#111111] py-24 px-4 sm:px-6" data-id="element-150">
      <div className="max-w-3xl mx-auto text-center" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-2xl shadow-gray-200/50 border border-gray-100 overflow-hidden" data-id="element-152">
          <div className="bg-[#111111] text-white py-4 px-6" data-id="element-153">
            <p className="text-sm font-bold tracking-widest uppercase text-[#E8652D]" data-id="element-154">
              Oferta de lanzamiento
            </p>
          </div>

          <div className="p-8 sm:p-12" data-id="element-155">
            <h2 className="text-3xl sm:text-4xl font-bold mb-4" data-id="element-156">
              Meal Prep Turbo
            </h2>
            <p className="text-gray-500 mb-8 text-lg" data-id="element-157">
              El sistema completo + plantillas + bonus
            </p>

            <div className="flex items-center justify-center gap-2 mb-8" data-id="element-158">
              <span className="text-6xl font-extrabold text-[#111111]" data-id="element-159">
                $6.39
              </span>
              <span className="text-xl text-gray-400 font-medium line-through" data-id="element-160">
                $29
              </span>
            </div>

            <div className="space-y-4 mb-10 text-left max-w-sm mx-auto" data-id="element-161">
              <div className="flex items-center gap-3" data-id="element-162">
                <div className="bg-green-100 p-1 rounded-full text-green-600" data-id="element-163">
                  <CheckIcon className="h-4 w-4" data-id="element-164" />
                </div>
                <span className="font-medium" data-id="element-165">
                  Sistema 3 Bases + 5 Variaciones
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-166">
                <div className="bg-green-100 p-1 rounded-full text-green-600" data-id="element-167">
                  <CheckIcon className="h-4 w-4" data-id="element-168" />
                </div>
                <span className="font-medium" data-id="element-169">Guía de Airfryer + Cocina</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-170">
                <div className="bg-green-100 p-1 rounded-full text-green-600" data-id="element-171">
                  <CheckIcon className="h-4 w-4" data-id="element-172" />
                </div>
                <span className="font-medium" data-id="element-173">Plantillas imprimibles</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-174">
                <div className="bg-green-100 p-1 rounded-full text-green-600" data-id="element-175">
                  <CheckIcon className="h-4 w-4" data-id="element-176" />
                </div>
                <span className="font-medium" data-id="element-177">Acceso inmediato (PDF)</span>
              </div>
            </div>

            <Button size="xl" fullWidth className="text-lg mb-6 shadow-xl shadow-[#E8652D]/20" onClick={() => window.open('https://multidigitalhub.com/cart/43558683476033:1', '_blank')} data-id="element-178">
              Descargar ahora por $6.39
              <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-179" />
            </Button>

            <p className="text-sm text-gray-500" data-id="element-180">
              Pago único. Acceso de por vida.
            </p>
          </div>
        </motion.div>

        <div className="mt-16 max-w-2xl mx-auto" data-id="element-181">
          <h3 className="text-xl font-bold mb-4" data-id="element-182">
            Para quién es / para quién no es
          </h3>
          <div className="grid sm:grid-cols-2 gap-8 text-left" data-id="element-183">
            <div data-id="element-184">
              <p className="font-bold text-green-600 mb-2 flex items-center gap-2" data-id="element-185">
                <CheckIcon className="h-4 w-4" data-id="element-186" /> Es para ti si:
              </p>
              <ul className="text-sm text-gray-600 space-y-2" data-id="element-187">
                <li data-id="element-188">• Tienes 25+ y quieres bajar grasa sin contar</li>
                <li data-id="element-189">• Estás cansado de improvisar</li>
                <li data-id="element-190">• Quieres algo repetible cada semana</li>
              </ul>
            </div>
            <div data-id="element-191">
              <p className="font-bold text-red-500 mb-2 flex items-center gap-2" data-id="element-192">
                <span className="text-xs" data-id="element-193">❌</span> No es para ti si:
              </p>
              <ul className="text-sm text-gray-600 space-y-2" data-id="element-194">
                <li data-id="element-195">• Quieres una dieta clínica o médica</li>
                <li data-id="element-196">• Buscas macros estrictos</li>
                <li data-id="element-197">• Compites en fitness</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-10 border-t border-gray-200" data-id="element-198">
          <p className="text-2xl font-serif italic text-gray-600 mb-6" data-id="element-199">
            "La semana que viene va a llegar igual… La diferencia es si llegas
            con un plan o con otra promesa de lunes."
          </p>
          <p className="text-sm text-gray-400" data-id="element-200">
            © 2024 Meal Prep Turbo. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </section>;
}